import React, { useState } from "react";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";
import useMobile from "../hooks/useMobile";
import useTab from "../hooks/useTab";
import { useShowUserMenu } from "../context/ShowUserMenuContext";
import logo from "../assets/images/frcsit-logo.png";

const AdminSideBar = () => {
  const [pathName, setPathName] = useState(window.location.pathname.slice(1));
  const { showUserMenu, setShowUserMenu } = useShowUserMenu();
  const mobile = useMobile();
  const tab = useTab();
  const linkClicker = (path: string) => {
    setPathName(path);
    const pathLocation = window.location.pathname.includes(path);
    if (!pathLocation) {
      window.scrollTo(0, 0);
    } else {
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
    setShowUserMenu(false);
  };

  return (
    <div
      className={`mobile-nav__wrapper ${
        ((!mobile && !tab) || showUserMenu) && "expanded"
      }`}
      style={{
        width: mobile || tab ? "100%" : "unset",
        top: mobile || tab ? 0 : "71px",
      }}
    >
      {(mobile || tab) && (
        <div
          className="mobile-nav__overlay mobile-nav__toggler"
          onClick={() => {
            setShowUserMenu(false);
          }}
        ></div>
      )}
      <div
        className="mobile-nav__content"
        style={{
          paddingTop: mobile || tab ? "default" : "unset",
          width: mobile || tab ? "default" : "240px",
        }}
      >
        {(mobile || tab) && (
          <>
            <span
              className="mobile-nav__close mobile-nav__toggler"
              onClick={() => {
                setShowUserMenu(false);
              }}
            >
              <i className="fa fa-times"></i>
            </span>

            <div className="logo-box">
              <a href="/" aria-label="logo image">
                <img height={mobile ? "40" : "60"} src={logo} alt="logo" />
              </a>
            </div>
          </>
        )}
        <div className="mobile-nav__container">
          <ul className="main-menu__list">
            <li className="dropdown megamenu">
              {/* <Link to="/"> */}
              <Link
                to="/admin/member-dashboard"
                onClick={() => linkClicker("admin/member-dashboard")}
                className={pathName === "admin/member-dashboard" ? "active-page" : ""}
              >
                Dashboard
              </Link>
            </li>
            <li className="dropdown megamenu">
              {/* <Link to="/about"> */}
              <Link
                to="/admin/members"
                onClick={() => linkClicker("admin/members")}
                className={
                  pathName === "admin/members" ||
                  pathName === "admin/members/edit"
                    ? "active-page"
                    : ""
                }
              >
                Members
              </Link>
            </li>
            <li className="dropdown megamenu">
              {/* <Link to="/about"> */}
              <Link
                to={`${process.env.REACT_APP_strapiUrl}/admin/content-manager`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Content Manager
              </Link>
            </li>
            <li className="dropdown megamenu">
              {/* <Link to="/about"> */}
              <Link
                to={`https://webmail.scieverinc.com/`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Check Webmail
              </Link>
            </li>
            {/* <li className="dropdown megamenu">
              <Link to="/about">
              <Link
                to="/admin/affliliates"
                onClick={() => linkClicker("admin/affliliates")}
                className={
                  pathName === "admin/affliliates" ? "active-page" : ""
                }
              >
                Affiliate Registration
              </Link>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AdminSideBar;
